import { render, staticRenderFns } from "./pdf_viewer.vue?vue&type=template&id=d10bfdec&scoped=true&"
import script from "./pdf_viewer.vue?vue&type=script&lang=js&"
export * from "./pdf_viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10bfdec",
  null
  
)

export default component.exports